
import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface TrackingToggleProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const TrackingToggle: React.FC<TrackingToggleProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onChange}
        disabled={disabled}
      />
      <Label 
        htmlFor={id} 
        className={`text-sm cursor-pointer ${
          disabled 
            ? 'text-gray-400 dark:text-gray-500' 
            : 'text-gray-700 dark:text-gray-300'
        }`}
      >
        {label}
      </Label>
    </div>
  );
};
